module.exports = __webpack_public_path__ + "fonts/31E180_4_0.6126a04.eot";